/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type FeatureFlagName = typeof FeatureFlagName[keyof typeof FeatureFlagName];


export const FeatureFlagName = {
  DRESSING_ROOM: 'dressing_room',
  FLEET_CONTRACTS: 'fleet_contracts',
  FLEET_LOGISTICS: 'fleet_logistics',
  FLEET_MISSION_BUILDER: 'fleet_mission_builder',
  FLEET_SUBSCRIPTIONS: 'fleet_subscriptions',
  FLEET_TOURS: 'fleet_tours',
  FLEETCHART_LAYOUTS: 'fleetchart_layouts',
  HANGAR_PLANNER: 'hangar_planner',
  HOLO_AR: 'holo_ar',
  HOLO_PHONE: 'holo_phone',
  HOLO_TEXTURED: 'holo_textured',
  ITEM_HOLO_TEXTURED: 'item_holo_textured',
  LOADOUT_PREVIEW: 'loadout_preview',
  OAUTH_APPLICATIONS: 'oauth-applications',
  OAUTH_BLUESKY: 'oauth-bluesky',
  OAUTH_CITIZENID: 'oauth-citizenid',
  OAUTH_DISCORD: 'oauth-discord',
  OAUTH_GITHUB: 'oauth-github',
  OAUTH_GOOGLE: 'oauth-google',
  OAUTH_PATREON: 'oauth-patreon',
  OAUTH_TWITCH: 'oauth-twitch',
  PAINT_BOOTH: 'paint_booth',
} as const;
